module.exports = __webpack_public_path__ + "age.3a68c32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile/age.png
// module id = 2492
// module chunks = 0